import { z } from 'zod';

export function createSearchSchema<T extends readonly [string, ...string[]]>(
  sortableColumnKeys: T,
) {
  return z.object({
    freeText: z.string().optional(),
    softwareIdIn: z.array(z.string()).optional(),
    pageIndex: z.number().default(0),
    pageSize: z.number().default(100),
    sortColumn: z.enum(sortableColumnKeys).optional(),
    sortOrder: z.enum(['asc', 'desc']).optional(),
  });
}
